import { useMutation } from '@tanstack/react-query';

import { Api } from '@/shared/api';
import { useCurrentProject } from '@/shared/projects/project-path';

export function useUpdateCategoryMutation() {
  const project = useCurrentProject();
  return useMutation({
    mutationFn: (data: Parameters<typeof Api.categories.updateCategory>[1]) =>
      Api.categories.updateCategory(project, data),
  });
}

export function useUploadCategoryPreviewMutation() {
  const project = useCurrentProject();
  return useMutation({
    mutationFn: (
      file: Parameters<typeof Api.categories.uploadCategoryPreview>[1],
    ) => Api.categories.uploadCategoryPreview(project, file),
  });
}
